import React from 'react'
import { DisplayIconProps } from '../DisplayIcon.d'

const Lock = ({ classes, color }: DisplayIconProps) => {
  let iconColor = color ? color : '#2B4FB9'
  return (
    <svg
      className={classes}
      data-testid='DisplayIcon-Lock'
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17 21.0499H7C5.9 21.0499 5 20.1499 5 19.0499V11.0499C5 9.94993 5.9 9.04993 7 9.04993H17C18.1 9.04993 19 9.94993 19 11.0499V19.0499C19 20.1499 18.1 21.0499 17 21.0499Z'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit='10'
        strokeWidth='1.5'
        data-testid='DisplayIcon-Lock-path'
        stroke={iconColor}
      />
      <path
        d='M16.3 8.54995V7.24995C16.3 4.84995 14.4 2.94995 12 2.94995C9.70005 3.04995 7.80005 4.94995 7.80005 7.24995V8.54995'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit='10'
        strokeWidth='1.5'
        stroke={iconColor}
      />
      <path
        d='M13 15.0499C13 15.6022 12.5523 16.0499 12 16.0499C11.4477 16.0499 11 15.6022 11 15.0499C11 14.4976 11.4477 14.0499 12 14.0499C12.5523 14.0499 13 14.4976 13 15.0499Z'
        fill={iconColor}
        stroke={iconColor}
      />
    </svg>
  )
}

export default Lock
